<template>
  <v-content>
    <app-menu :menus="menus" :homeUrl="homeUrl" :profileRouter="'adm-profile'" :helpRouter="'adm-help'"></app-menu>
    <router-view name="content" class="container"></router-view>
  </v-content>
</template>

<script>
import Footer from "../shared/UserFooter.vue";
// import Navbar from "../shared/UserNavbar.vue";
import MenuModel from "../../models/Menu.js";
import Menu from "../shared/Menu.vue";

export default {
	data: function () {
		return { 
            homeUrl: '/adm/reservas',
		}
	},
  computed: {
    menus() {
      return [
        new MenuModel("Cadastro de usuários", "nc-icon nc-single-02", "plus-driver"),
        new MenuModel("Programas", "nc-icon nc-single-02", "plus-programs"),
      ];
    }
  },  

  components: {
    "app-footer": Footer,
    // "app-nav": Navbar,
    "app-menu": Menu
  }
};
</script>

